var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconNewCertificate = function SvgIconNewCertificate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-168 -246) translate(168 246.125)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "#1A171B"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z",
    transform: "translate(4 3.875)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F6BF00",
    d: "M10.9 8.516c0 .849-.687 1.536-1.535 1.536-.847 0-1.535-.687-1.535-1.536 0-.848.688-1.534 1.535-1.534.848 0 1.534.686 1.534 1.534",
    transform: "translate(4 3.875) translate(1.333 1.333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A171B",
    d: "M2.925 5.604c-.283 0-.513-.23-.513-.515 0-.283.23-.513.513-.513h3.28c.284 0 .515.23.515.513 0 .284-.231.515-.514.515h-3.28zm0 2.186c-.283 0-.513-.23-.513-.514 0-.296.23-.526.513-.526h3.28c.284 0 .515.23.515.514 0 .296-.231.526-.514.526h-3.28zm0 2.187c-.283 0-.513-.23-.513-.515 0-.295.23-.526.513-.526h3.28c.284 0 .515.23.515.514 0 .296-.231.527-.514.527h-3.28zM1.805 1.23c-.304 0-.552.247-.552.551v9.889c0 .304.248.55.552.55h9.881c.304 0 .551-.246.551-.55V3.976c0-.304-.247-.551-.551-.551H8.98v.006H6.407c-.263 0-.521-.108-.708-.295L3.814 1.241l-2.01-.01zm0 12.018c-.872 0-1.58-.708-1.58-1.578V1.782c0-.87.708-1.58 1.58-1.58h2.013c.264 0 .522.108.708.295L6.41 2.393l2.57.01.033.006h2.673c.87 0 1.58.708 1.58 1.579v7.683c0 .87-.71 1.578-1.58 1.578H1.805z",
    transform: "translate(4 3.875) translate(1.333 1.333)"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNewCertificate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_new_certificate.8e8c8869.svg";
export { ForwardRef as ReactComponent };